import { memo, useMemo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";

import cn from "classnames";
import {
  ATHLETE_TABLE_HEADER,
  ATHLETE_TABLE_HEADER_FREE_FORM,
} from "constants/patientDetails";
import { icons } from "constants/icons";
import {
  FilterParams,
  FILTER_KEYS,
  SortConfig,
  SortDirection,
} from "types/common";
import { FilterDropdown } from "components/FilterDropdown/FilterDropdown";
import { selectTypeFilterParams } from "store/PatientStore/selectors";
import { selectJointFilterParams } from "store/PatientStore/selectors";
import { changeFilterParams } from "store/PatientStore/actions";

type Props = {
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
  isFreeForm?: boolean;
};

export const VideoExamTableHeader = memo(
  ({ onClick, sortConfig, isFreeForm }: Props) => {
    const jointFilterParams = useAppSelector(selectJointFilterParams);
    const typeFilterParams = useAppSelector(selectTypeFilterParams);
    const dispatch = useAppDispatch();

    const filterParamsMap: Record<FILTER_KEYS, FilterParams[]> = useMemo(() => {
      return {
        [FILTER_KEYS.joint]: jointFilterParams,
        [FILTER_KEYS.type]: typeFilterParams,
      };
    }, [jointFilterParams, typeFilterParams]) as Record<
      FILTER_KEYS,
      FilterParams[]
    >;

    const filterParamsTitleMap: Record<FILTER_KEYS, string> = useMemo(() => {
      return {
        [FILTER_KEYS.joint]: "Region",
        [FILTER_KEYS.type]: "Type",
      };
    }, []) as Record<FILTER_KEYS, string>;

    const onApplyRegionFilters = useCallback(
      (filterKey: FILTER_KEYS, filterParams: FilterParams[]) => {
        dispatch(changeFilterParams(filterKey, filterParams));
      },
      [dispatch]
    );

    const onResetRegionFilters = useCallback(
      (filterKey: FILTER_KEYS, filterParams: FilterParams[]) => {
        dispatch(changeFilterParams(filterKey, filterParams));
      },
      [dispatch]
    );
    const TABLE_HEAD = isFreeForm
      ? ATHLETE_TABLE_HEADER_FREE_FORM
      : ATHLETE_TABLE_HEADER;
    return (
      <div className="flex px-4 mt-4">
        {TABLE_HEAD.map((item, index) => {
          const handleClick = () => {
            onClick(item.sortName ?? "");
          };
          return (
            <div
              key={item.title}
              className={cn("flex text-[10px] text-grayDark relative")}
              style={{ width: item.width, marginLeft: item?.marginLeft || 0 }}
            >
              {item.title && (
                <button
                  type="button"
                  className="flex space-x-2 items-center"
                  onClick={handleClick}
                >
                  <strong>{item.title}</strong>

                  <img
                    src={icons.carrotDown}
                    alt="arrow"
                    className={cn("transition-all mt-[0.5px]", {
                      "rotate-180":
                        sortConfig.sortBy === item?.sortName &&
                        sortConfig.sortDirection === SortDirection.asc,
                    })}
                  />
                </button>
              )}
            </div>
          );
        })}
      </div>
    );
  }
);
